module.exports = __webpack_public_path__ + "img/logo.7ee22bd6.png";